import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {LoadingService} from "../../../services/LoadingService";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {ToastService} from "../../../services/Toast.service";
import {StateService} from "../../../services/StateService";
import {State} from "../../../models/State";
import {SwitchBoard} from "../../../services/SwitchBoard";
import {Router} from "@angular/router";
import {PageTitleService} from "../../../services/PageTitle";
import {takeUntil} from "rxjs/operators";
import {Session} from "../../../services/Session";
import {VendorsService} from "../../../tpiq-services/vendors.service";
import {CreateOrUpdateVendorComponent} from "../create-or-update-vendor/create-or-update-vendor.component";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatTooltipModule} from "@angular/material/tooltip";
import {TpiqFroalaViewComponent} from "../../../tpiq-froala-view/tpiq-froala-view.component";

declare let _: any;

@Component({
  selector: 'app-vendors-list',
  standalone: true,
  imports: [CommonModule, FormsModule, CreateOrUpdateVendorComponent, MatButtonModule, MatIconModule, MatMenuModule, MatTooltipModule,
    TpiqFroalaViewComponent],
  templateUrl: './vendors-list.component.html',
  styleUrl: './vendors-list.component.scss'
})
export class VendorsListComponent implements OnInit, OnDestroy {
  routeSub: any;
  user: any;
  org: string;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  searchKey: string;
  vendorsData: any;

  reveal: any = {
    addOrEditVendor: false,
  };
  editMode = false;
  vendorId: any;


  constructor(
    private _router: Router,
    private loadingService: LoadingService,
    private toastService: ToastService,
    private stateService: StateService,
    private switchBoard: SwitchBoard,
    private titleService: PageTitleService,
    private vendorsService: VendorsService
  ) {
  }

  ngOnInit(): void {
    this._init();
  }

  _init() {
    this.org = Session.getOrg();
    this.user = Session.getUser().id;
    this.titleService.setPageTitle('');
    this.getAllVendorsData();
    this.switchBoard.onPageChangeListener.next({});
    this.switchBoard.onClickPrev.pipe(takeUntil(this.destroy$)).subscribe(obj => {
      const prevState = this.stateService.getPrevState();
      if (prevState) {
        this.stateService.pop();
        this._router.navigate([prevState.url]);
      }
    });
    this.switchBoard.onToastConfirm.pipe(takeUntil(this.destroy$)).subscribe(toast => {
      if (toast.data) {
        this.removeVendor(toast.data);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  addNewVendor() {
    this.editMode = false;
    this.reveal.addOrEditVendor = true;
  }

  openVendor(vendor) {
    this.vendorId = vendor.id;
    this.editMode = true;
    this.reveal.addOrEditVendor = true;
  }

  viewVendor(vendor) {
    this.stateService.addState(new State('view-vendor', this._router.url, {fromStrategyPage: false}, null));
    const link = ['tax-planning/vendor', vendor.id, 'view'];
    this._router.navigate(link);
  }

  getAllVendorsData() {
    this.loadingService.triggerLoadingEvent(true);
    this.vendorsService.getAllVendors(this.org, this.user, -1, this.searchKey)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        this.vendorsData = response;
        if (this.vendorsData && this.vendorsData.vendors && this.vendorsData.vendors.length > 0) {
          _.each(this.vendorsData.vendors, function(vendor){
            vendor.logoBg = {
              background: 'url("' + vendor.logo + '") center center no-repeat',
              'background-size': 'contain'
            };
            if(vendor.description) {
              vendor.description = _.replace(vendor.description, '<pre', '<p');
              vendor.description = _.replace(vendor.description, '/pre>', '/p>');
            }
          });
        }
      }, (error) => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed To get vendors data`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }


  deleteVendor(vendor) {
    this.toastService.pop(TOAST_TYPE.confirm, 'Are you sure you want to delete?', vendor);
  }

  removeVendor(vendor) {
    this.loadingService.triggerLoadingEvent(true);
    this.vendorsService.removeVendor(this.org, this.user, vendor.id)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Vendor deleted successfully');
        this.getAllVendorsData();
      }, (error) => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed to delete vendor`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  filterData() {
    this.getAllVendorsData();
  }

  searchKeyUp() {
    if (this.searchKey.length <= 0) {
      this.filterData();
    }
  }

  hideReveal(key){
    this.vendorId = '';
    this.editMode = false;
    this.reveal[key] = false;
  }

  refreshListOfVendors() {
    this.reveal.addOrEditVendor = false;
    this.getAllVendorsData();
  }

  showStrategy(strategy) {
    this.stateService.addState(new State('', this._router.url, null, '', null));
    this._router.navigate(['tax-planning', 'taxStrategies', strategy.strategyId]);
  }

}
